import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { bookingFormCommon } from "./c005-bookingform-common";

export class dealsAlertWidget{
	private $dealsAlertEmail: string = '';
	private $dealsAlertError:Array<string> = [];

	$scope: any = $('.deals-alert--container');
	$dealsAlertEmailInput: any =  $('#dealsAlertEmail');
	$dealsAlertPreferredCity: any = $('#dealsAlertpreferredCity');
	$dealsAlertValidator: any = $('#dealsalert-validator');
	$dealsAlertErrorValidation: any = $('.dealsalert-error--validation');
	$dealsAlertSubmitBtn: any = $('#dealsAlertSubmit');
	$dealsAlertSuccess: any = $('.deals-alert--success');
	$dealsAlertHolder: any = $('.deals-alert--holder');

	validateEmail($dealsAlertEmail:string):boolean{
		let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
				return emailReg.test($dealsAlertEmail);
	}

	initSelectize(listItems: string): void {
		let _self = this;

		let $dealsAlertpreferredCitySel: any = $('#dealsAlertpreferredCity');
		let $dealsAlertpreferredCity: any = $('.dealsAlertpreferredCity');

		$dealsAlertpreferredCitySel.html(listItems);
		$dealsAlertpreferredCitySel.selectize({
			onFocus: function() {
				$dealsAlertpreferredCity.find('.booking-form--title').addClass('input-filled');
				$dealsAlertpreferredCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$dealsAlertpreferredCitySel.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$dealsAlertpreferredCitySel.parent().find('.booking-form--title').removeClass('has-error');
			},
			onChange: function() {
				$dealsAlertpreferredCity.find('.booking-form--title').addClass('input-filled');
				$dealsAlertpreferredCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
			},
			onBlur: function(){
				let $preferredCityChange = $dealsAlertpreferredCitySel.find('option:selected').text();
				if($preferredCityChange == ''){
					$dealsAlertpreferredCity.find('.booking-form--title').removeClass('input-filled');
					$dealsAlertpreferredCity.find('.selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$dealsAlertpreferredCity.find('.booking-form--title').addClass('input-filled');
					$dealsAlertpreferredCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
				}
			}
		});
	}

	dealsAlertForm(): void {
		let _self = this;
		if(_self.$scope.length == 0) return
		_self.$dealsAlertSubmitBtn.click((evt:any) => {
				evt.preventDefault();
				this.$dealsAlertError = [];
				_self.$dealsAlertErrorValidation.show();
				let $dealsAlertEmail = _self.$dealsAlertEmailInput.val();
				if((!(this.validateEmail($dealsAlertEmail))) || $dealsAlertEmail == ''){
					let $dealsAlertEmailValidate:any = _self.$dealsAlertEmailInput.attr('data-dealsemail');
					this.$dealsAlertError.push($dealsAlertEmailValidate);
					_self.$dealsAlertEmailInput.addClass('has-error');
					_self.$dealsAlertEmailInput.parent().find('.booking-form--title').addClass('has-error');
				} else{
					_self.$dealsAlertEmailInput.removeClass('has-error');
					_self.$dealsAlertEmailInput.parent().find('.booking-form--title').removeClass('has-error');
				}
				if(_self.$dealsAlertPreferredCity.val() == ''){
					_self.$dealsAlertPreferredCity.parent().find('.selectize-control .selectize-input').addClass('has-error');
					_self.$dealsAlertPreferredCity.parent().find('.booking-form--title').addClass('has-error');
					let $preferredCityValidate:any = _self.$dealsAlertPreferredCity.attr('data-dealspreferredcity');
					this.$dealsAlertError.push($preferredCityValidate);
				} else{
					_self.$dealsAlertPreferredCity.parent().find('.selectize-control .selectize-input').removeClass('has-error');
					_self.$dealsAlertPreferredCity.parent().find('.booking-form--title').removeClass('has-error');
				}
				_self.$dealsAlertValidator.text(this.$dealsAlertError.join(', '));
				if(this.validateEmail($dealsAlertEmail) || _self.$dealsAlertEmailInput.val() != '' || _self.$dealsAlertPreferredCity.val() != ''){
					if(!($('.dealsAlertpreferredCity .selectize-control .selectize-input').hasClass('has-error') || $('.dealsAlertEmail .booking-form--title').hasClass('has-error'))){
						_self.$dealsAlertSuccess.show();
						_self.$dealsAlertErrorValidation.hide();
						_self.$dealsAlertHolder.hide();
					}
				}
		});
	}
}

let scope:Element = document.querySelector('.deals-alert--container');
if (scope){
	try {
		let bookingformcommon = new bookingFormCommon();
		let dealsalertwidget = new dealsAlertWidget();

		$.when(window['ibeOnDList']).done((listData: any) => {
			console.log('%cc018dealsalert%c ond done', 'background-color: yellow', 'background-color: initial');
			let listItems:string = bookingformcommon.parseNewsletterListItems(listData);
			dealsalertwidget.initSelectize(listItems);
		});
		dealsalertwidget.dealsAlertForm();
	} catch(e) {console.error(e);}
}
